// extracted by mini-css-extract-plugin
export default {"free":"pricingCard_free__nJcW5","standard":"pricingCard_standard__Udwj8","premium":"pricingCard_premium__o7wlF"};